import './assets/css/App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import { } from 'react-router-dom';
import AuthLayout from './layouts/auth';
import SignInDefault from 'views/auth/signIn/SignInDefault';
// import jwt from 'jsonwebtoken';
//import { Secret, decode, verify } from 'jsonwebtoken';


import AdminLayout from './layouts/admin';
// import RTLLayout from './layouts/rtl';
// import encuestas from './layouts/encuestas';
import {
  ChakraProvider,
  // extendTheme
} from '@chakra-ui/react';
import initialTheme from './theme/theme'; //  { themeGreen }
import { useEffect, useState } from 'react';
import { getCookie } from 'cookies-next';
// import AjustePositivo from 'views/admin/main/ERP/Configuracion/AjustePositivo';
import Encuestas from 'views/admin/main/ERP/Candidatos/Encuestas';
// import { redirect } from 'react-router-dom';
// import { Redirect } from 'react-router-dom';
// Chakra imports

export default function Main() {
  // eslint-disable-next-line
  const [currentTheme, setCurrentTheme] = useState(initialTheme);
  const token = getCookie('token')

  useEffect(() => {
    const originalFetch = window.fetch.bind(window);
    const apiBaseUrl = (process.env.REACT_APP_URL_SERVER || '').trim();

    window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
      const requestUrl =
        typeof input === 'string'
          ? input
          : input instanceof URL
            ? input.toString()
            : input.url;

      const shouldAttachToken =
        !!apiBaseUrl && (requestUrl.startsWith(apiBaseUrl) || requestUrl.startsWith('/'));

      if (!shouldAttachToken) {
        return originalFetch(input, init);
      }

      const sessionToken = getCookie('token');
      if (!sessionToken || typeof sessionToken !== 'string') {
        return originalFetch(input, init);
      }

      const headers = new Headers(init?.headers || (input instanceof Request ? input.headers : undefined));
      if (!headers.has('Authorization')) {
        headers.set('Authorization', `Bearer ${sessionToken}`);
      }

      return originalFetch(input, {
        ...init,
        headers,
      });
    };

    return () => {
      window.fetch = originalFetch;
    };
  }, []);
  // const decoded = jwt.verify(token, "2C44-4D44-WppQ38S");
  // var id =decoded.usuarioid
  return (
    <ChakraProvider theme={currentTheme}>
      <Routes>
        {/* <Route path="auth/*" element={<AuthLayout />} /> */}
        {/* <Route path="/admin/*">
          {getCookie('token') ? <Route
          path="/admin/*"
          element={
            <AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />
          }
        /> : <Route path="/login" element={<SignInDefault />} />}
        </Route> */}
        <Route
          path="admin/*"
          element={
            getCookie('token') ?
              <AdminLayout theme={currentTheme} setTheme={setCurrentTheme} path="/admin/dashboards/default" />
              : <SignInDefault />

          }
        />
        {/* <Route
          path="rtl/*"
          element={
            <RTLLayout theme={currentTheme} setTheme={setCurrentTheme} />
          }
        /> */}
        <Route path="/" element={<Navigate to="/admin" replace />} />
    

        <Route path="encuesta/:id" element={<Encuestas />} />

      </Routes>
    </ChakraProvider>
  );
}
